export const TOKEN_COOKIE_CONFIG = {
  secure: true,
  sameSite: "strict",
};

export const API_URL = import.meta.env.VITE_API_URL;
